import { App } from 'vue';
import VueGtag, { useGtag, isTracking } from 'vue-gtag-next';
import keycloak from '../keycloak';

export type AnalyticsEvent =
  | 'select_solution'
  | 'switch_landing_tab'
  | 'view_manager_details'
  | 'download_pdf'
  | 'open_navbar_dropdown'
  | 'solution_step_progress'
  | 'logout';

export type AnalyticsParams = Record<string, string | number | boolean | undefined>;

let analyticsEnabled = false;

export function isAnalyticsEnabled(): boolean {
  return analyticsEnabled;
}

export function installAnalytics(app: App): void {
  const measurementId = process.env.VUE_APP_GA4_MEASUREMENT_ID;

  if (!measurementId) {
    console.info('[analytics] disabled: VUE_APP_GA4_MEASUREMENT_ID not set');
    return;
  }

  if (keycloak.hasRealmRole('Admin')) {
    console.info('[analytics] disabled: admin user');
    return;
  }

  const userId = keycloak.tokenParsed?.sub;

  app.use(VueGtag, {
    property: {
      id: measurementId,
      params: {
        send_page_view: false,
        ...(userId ? { user_id: userId } : {}),
      },
    },
  });

  analyticsEnabled = true;
}

export function trackEvent(name: AnalyticsEvent, params: AnalyticsParams = {}): void {
  if (!analyticsEnabled || !isTracking.value) return;
  const cleaned: AnalyticsParams = {};
  for (const [key, value] of Object.entries(params)) {
    if (value !== undefined && value !== null && value !== '') cleaned[key] = value;
  }
  useGtag().event(name, cleaned);
}
